import { Component } from '@angular/core';

@Component({
  selector: 'app-no-access-page',
  imports: [],
  templateUrl: './no-access-page.component.html',
  styleUrl: './no-access-page.component.scss'
})
export class NoAccessPageComponent {

}
